
let scrollValue_3 = 1;
let activeP3 = false;
let initFini_3 = false;
let titre_3 = document.getElementById("page3Titre");
let _scroll_3 = document.getElementById("page3Scroll");

window.addEventListener('wheel', onWheel);

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeP3) {  // Vérifie si la touche appuyée est 'Escape'
        //activeP3 = false
    }
});
  

let lastScrollTime_3 = 0; // Stocke le dernier timestamp d'exécution

function onWheel(event) {
    /*
    const now = Date.now(); // Récupère le temps actuel en millisecondes

    if (now - lastScrollTime_3 < 700) {
        return;
    }

    lastScrollTime_3 = now; // Met à jour le dernier temps d'exécution

    if (activeP3 && initFini_3) {
        const direction = Math.sign(event.deltaY); // -1 pour haut, 1 pour bas
        scrollValue_3 += direction;
        if (scrollValue_3 < 1) {
            scrollValue_3 = 2;
        }
        if (scrollValue_3 > 2) {
            scrollValue_3 = 1;
        }
        Scroll3(direction);

        window.animateJumpingLetters("page3Titre", 50, 200, 20, direction < 0);
        
    }*/
}

/*
const images = document.querySelectorAll('.unitystration_image');
let prevPosX = 0;
let PosX = 0;
let prevPosY = 0;
let PosY = 0;
images.forEach(image => {
    let isHovered = false;

    image.addEventListener('mouseenter', () => {
        isHovered = true;
        image.classList.add('hovered');
    });

    image.addEventListener('mouseleave', () => {
        isHovered = false;
        image.classList.remove('hovered');
    });

    image.addEventListener('mousemove', (e) => {
        if (isHovered) {

            const boundingBox = image.getBoundingClientRect();
            const offsetX = e.clientX - boundingBox.left;
            const offsetY = e.clientY - boundingBox.top;

            PosX = (((offsetX / boundingBox.width - 0.5) * 10) + prevPosX*29)/30;
            PosY = (((offsetY / boundingBox.height - 0.5) * 10) + prevPosY*29)/30;
            prevPosX = PosX; 
            prevPosY = PosY;

            image.style.transform = `translate(${PosX}px, ${PosY}px)`;

        }
    });
});*/


/* <div id="unity1Container">
    <p id="unity1Text"> voila le texte de l'unity 1 </p>
    <div id="unity1ImageContainer">
        <img id="unity1" onclick="FullUnity()" src="src/png/unitystrations/1.png" alt="unitystration 1"> 
    </div>
</div> */

function FullUnity(){

}

function Scroll3(direction){
    let passe = scrollValue_3-direction;
    if (passe<1) {
        passe = 2;
      }
      if (passe>2) {
        passe = 1;
      }

    let prevUnityContainer = document.getElementById("unity"+ passe +"Container");
    let prevUnityText = document.getElementById("unity"+ passe +"Text");
    let prevUnityImageContainer = document.getElementById("unity"+ passe +"ImageContainer");
    let prevUnityImage = document.getElementById("unity"+ passe);
    let unityContainer = document.getElementById("unity"+ scrollValue_3 +"Container");
    let unityText = document.getElementById("unity"+ scrollValue_3 +"Text");
    let unityImageContainer = document.getElementById("unity"+ scrollValue_3 +"ImageContainer");
    let unityImage = document.getElementById("unity"+ scrollValue_3);
    prevUnityContainer.style.zIndex = 70;
    unityContainer.style.zIndex = 80;

    unityImage.style.pointerEvents = "all";
    prevUnityImage.style.pointerEvents = "none";
    
        console.log(passe + " vers " + scrollValue_3)
        let actualopacity = window.getComputedStyle(prevUnityContainer).opacity;
        const actualx = gsap.getProperty(prevUnityImageContainer, "x");
        console.log(actualx);
        gsap.to(prevUnityContainer, {
            opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });
        gsap.to(prevUnityImageContainer, {
            y: 200*direction,
            height: 0,
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });

        gsap.to(unityContainer, {
            opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });
        gsap.fromTo(unityImageContainer, {
            y: -200*direction,
            height: 0},{
            y: 0 ,
            height: 400,
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });

    setTimeout(() => {
        
    }, 2000);  // Délai
    window.animateText("unity"+ scrollValue +"Text",30,50,false,1,true)
}

let unity1Container = document.getElementById("unity1Container");
let unity1Text_3 = document.getElementById("unity1Text");
let unity1ImageContainer_3 = document.getElementById("unity1ImageContainer");
let unity1Image_3 = document.getElementById("unity1");
function unity1() {
    setTimeout(() => {
        
        gsap.fromTo(unity1Container, {
            opacity: 0,  // Valeur de départ (l'élément est visible)
        }, {
            opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
            duration: 2,  // Durée de l'animation
            ease: "power4.Out"  // Courbe d'accélération
        });
        gsap.fromTo("#unity1ImageContainer", 
            {
                height: "400px",
                x: "400px",  // Valeur de départ
                y: "0px"
            }, 
            {
                height: "400px",
                x: "0px",  // Valeur de fin
                y: "0px",
                duration: 2,
                ease: "power4.out",  // Courbe d'accélération
                overwrite: "auto"
            });
          
    }, 500);  // Délai
    setTimeout(() => {
        initFini_3 = true;
    }, 2500);  // Délai
    window.animateText("unity1Text",30,1000,false,1,true)
}


    unity1Container.style.opacity = 0;
    unity1Container.style.zIndex = 8;




titre_3.style.opacity = 0;
_scroll_3.style.opacity = 0;

///id, delay, offset, scint
function page3Start() {
    document.getElementById("page3").style.display = "flex";

    unity1Container.style.opacity = 0;
    unity1Container.style.zIndex = 8;
    gsap.set("#unity1ImageContainer", {y: 400});
    unity1Image_3.style.pointerEvents = "all";
    initFini_3 = false;
    scrollValue_3 = 1;
    window.animateText("page3Titre",90,200,false);
    //window.animateText("page3Scroll",90,2000,true);
    unity1();
    setTimeout(() => {
        window.animateJumpingLetters("page3Titre",5,2,0);
    }, 2000);  // Délai
    activeP3 = true;
    gsap.to("#page3", {
        opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
        duration: 1,  // Durée de l'animation
        ease: "power2.inOut"  // Courbe d'accélération
    });
    gsap.to("#page3Bg", {
        opacity: 0.5,  // Valeur d'arrivée (l'élément disparaît)
        duration: 2,  // Durée de l'animation
        ease: "power2.inOut"  // Courbe d'accélération
    });
}

function page3End() {
    document.getElementById("page3").style.display = "none";
    activeP3 = false;
    gsap.to("#page3", {
        opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
        duration: 1.5,  // Durée de l'animation
        ease: "power2.Out"  // Courbe d'accélération
    });

}

document.getElementById("page3").style.display = "none";
// Attacher la fonction à `window`
window.page3Start = page3Start;
window.page3End = page3End;